import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { GatewayService } from "app/shared/gateway.service";

@Component({
  selector: "app-grafana-item",
  standalone: false,
  templateUrl: "./grafana-item.component.html",
  styleUrl: "./grafana-item.component.css",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GrafanaItemComponent {

  gatewayId: string;
  iframeSrc = signal<string>(null);

  constructor(private gatewayService: GatewayService, private activatedRoute: ActivatedRoute, public sanitizer: DomSanitizer) {
    this.gatewayId = activatedRoute.snapshot.params['gatewayid'];
    gatewayService.getSimpleGateway(this.gatewayId).then(gateway => {
      this.iframeSrc.set(`https://grafana.4dml.com/public-dashboards/${gateway.grafana_key}?theme=light&kiosk=true&hideLogo=true`);
    });
  }
}
